import React, { useState, useEffect } from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  TextField,
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import Autocomplete from "@material-ui/lab/Autocomplete";

import { useAlert } from "react-alert";

import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import EventIcon from "@material-ui/icons/Event";
import PersonIcon from "@material-ui/icons/Person";
import ReceiptIcon from "@material-ui/icons/Receipt";
import VisibilityIcon from "@material-ui/icons/Visibility";

import {
  printLot,
  AuctionListLimit,
} from "../../../adminModel/auctions";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  card: {
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    boxShadow: "none",
    overflow: "hidden",
    backgroundColor: "#fff",
  },

  sectionHeader: {
    padding: theme.spacing(2.25, 2.5),
    backgroundColor: "#fafafa",
  },

  sectionTitle: {
    fontWeight: 600,
    color: "#1f2937",
  },

  sectionSubtitle: {
    marginTop: 3,
    color: "#6b7280",
  },

  headerIcon: {
    width: 38,
    height: 38,
    minWidth: 38,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#eef2ff",
    color: theme.palette.primary.main,
    marginRight: 12,
  },

  content: {
    padding: theme.spacing(2.5),
  },

  field: {
    marginBottom: theme.spacing(2),

    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },

  lotField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },

    "& textarea": {
      lineHeight: 1.7,
    },
  },

  addOnsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },

  addOnsTitle: {
    fontWeight: 600,
    color: "#374151",
  },

  addOnRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.25),

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },

  addOnDescription: {
    flex: 2,

    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },

  addOnPrice: {
    flex: 1,

    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },

  addOnAction: {
    width: 38,
    height: 38,
  },

  summaryBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.75),
    borderRadius: 10,
    border: "1px solid #e5e7eb",
    backgroundColor: "#f8fafc",
  },

  summaryTitle: {
    fontWeight: 600,
    color: "#374151",
    marginBottom: theme.spacing(1),
  },

  summaryRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 0",
  },

  summaryLabel: {
    color: "#6b7280",
    fontSize: 13,
  },

  summaryValue: {
    color: "#111827",
    fontSize: 13,
    fontWeight: 600,
  },

  totalRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 10,
    marginTop: 8,
    borderTop: "1px solid #d1d5db",
  },

  totalLabel: {
    color: "#111827",
    fontSize: 14,
    fontWeight: 700,
  },

  totalValue: {
    color: "#111827",
    fontSize: 15,
    fontWeight: 700,
  },

  actionSection: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  },

  previewButton: {
    minHeight: 42,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    paddingLeft: 18,
    paddingRight: 18,
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  lotCount: {
    marginTop: theme.spacing(1.5),
    padding: "8px 12px",
    borderRadius: 8,
    backgroundColor: "#f8fafc",
    border: "1px solid #e5e7eb",
    fontSize: 13,
    color: "#6b7280",
  },
}));

const Views = () => {
  const classes = useStyles();
  const alert = useAlert();

  // =========================
  // STATE
  // =========================

  const [customerName, setName] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [consignorPercent, setConsignorPercent] =
    useState(0.112);

  const [lotNumberData, setLotNumber] =
    useState("");

  const [geteventList, setEventList] =
    useState([]);

  const [eventId, setEventId] =
    useState("");

  const [eventName, setEventName] =
    useState("");

  const [dateStart, setDateStart] =
    useState("");

  const [data1, setData1] =
    useState([]);

  const [totalSub, setTotalSub] =
    useState(0);

  const [inputs, setInputs] = useState([
    {
      discription: "",
      price: 0,
    },
  ]);

  // =========================
  // LOAD EVENTS
  // =========================

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const results =
          await AuctionListLimit();

        setEventList(
          results?.data || []
        );
      } catch (error) {
        console.error(
          "Failed to load auction list:",
          error
        );

        alert.error(
          "Failed to load events."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // =========================
  // EVENT PICK
  // =========================

  const handlepick = (
    event,
    value
  ) => {
    if (!value) {
      setEventName("");
      setEventId("");
      setDateStart("");
      setData1([]);
      setTotalSub(0);

      return;
    }

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    const dateValue =
      value.date_start
        ? new Date(
            value.date_start.slice(
              0,
              10
            )
          )
        : null;

    setEventName(
      value.auction_name || ""
    );

    setDateStart(
      dateValue
        ? dateValue.toLocaleDateString(
            "en-US",
            options
          )
        : ""
    );

    setEventId(value.id);

    if (lotNumberData) {
      FinLot(
        value.id,
        lotNumberData
      );
    } else {
      setData1([]);
      setTotalSub(0);
    }
  };

  // =========================
  // FIND LOT
  // =========================

  const FinLot = async (
    id,
    lots
  ) => {
    try {
      const results =
        await printLot(
          lots,
          id
        );

      if (
        !results ||
        results.length === 0
      ) {
        setData1([]);
        setTotalSub(0);

        return;
      }

      const sortedResults = [
        ...results,
      ].sort(
        (a, b) =>
          Number(
            a.lot_number || 0
          ) -
          Number(
            b.lot_number || 0
          )
      );

      setData1(
        sortedResults
      );

      setTotalSub(
        results.reduce(
          (sum, item) =>
            sum +
            parseFloat(
              item.hp || 0
            ),
          0
        )
      );
    } catch (error) {
      console.error(
        "Failed to load lots:",
        error
      );

      setData1([]);
      setTotalSub(0);

      alert.error(
        "Failed to load lot details."
      );
    }
  };

  // =========================
  // LOT NUMBER
  // =========================

  const handleLotNumberChange = (
    event
  ) => {
    const value =
      event.target.value;

    const lots = value
      .replace(/\n/g, ",")
      .replace(/\s/g, "");

    setLotNumber(lots);

    if (eventId) {
      FinLot(
        eventId,
        lots
      );
    }
  };

  // =========================
  // ADD INPUT
  // =========================

  const handleAddInput = () => {
    setInputs([
      ...inputs,
      {
        discription: "",
        price: 0,
      },
    ]);
  };

  // =========================
  // CHANGE INPUT
  // =========================

  const handleChange = (
    event,
    index
  ) => {
    const {
      name,
      value,
    } = event.target;

    const newInputs = [
      ...inputs,
    ];

    newInputs[index] = {
      ...newInputs[index],
      [name]: value,
    };

    setInputs(
      newInputs
    );
  };

  // =========================
  // DELETE INPUT
  // =========================

  const handleDeleteInput = (
    index
  ) => {
    if (
      inputs.length === 1
    ) {
      setInputs([
        {
          discription: "",
          price: 0,
        },
      ]);

      return;
    }

    setInputs(
      inputs.filter(
        (_, i) =>
          i !== index
      )
    );
  };

  // =========================
  // CALCULATIONS
  // =========================

  const totalAddons =
    inputs.reduce(
      (total, item) =>
        total +
        parseFloat(
          item.price || 0
        ),
      0
    );

  const commissionValue =
    Math.round(
      totalSub *
        consignorPercent
    );

  const totalDue =
    totalSub -
    commissionValue -
    totalAddons;

  // =========================
  // FORMAT MONEY
  // =========================

  const formatMoney = (
    value
  ) => {
    return parseFloat(
      value || 0
    ).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }
    );
  };

  // =========================
  // ESCAPE HTML
  // =========================

  const escapeHtml = (
    value
  ) => {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    return String(value)
      .replace(
        /&/g,
        "&amp;"
      )
      .replace(
        /</g,
        "&lt;"
      )
      .replace(
        />/g,
        "&gt;"
      )
      .replace(
        /"/g,
        "&quot;"
      )
      .replace(
        /'/g,
        "&#039;"
      );
  };

  // =========================
  // VIEW / PRINT PREVIEW
  // =========================

  const handlePreviewPrint = () => {
    if (!eventId) {
      alert.error(
        "Please select an event first."
      );

      return;
    }

    if (
      !customerName.trim()
    ) {
      alert.error(
        "Please enter the consignor name."
      );

      return;
    }

    if (
      !data1 ||
      data1.length === 0
    ) {
      alert.error(
        "Please enter at least one valid lot number."
      );

      return;
    }

    // Open immediately to avoid popup blocker
    const printWindow =
      window.open(
        "",
        "_blank",
        "width=1100,height=900"
      );

    if (!printWindow) {
      alert.error(
        "Please allow pop-ups for this page."
      );

      return;
    }

    const now = new Date();

    const printDate =
      now.toLocaleString(
        "en-PH",
        {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
        }
      );

    // =========================
    // LOT ROWS
    // =========================

    const lotRows = data1
      .map((value) => {
        const artist =
          value.artist || "";

        const title =
          value.title || "";

        return `
          <tr class="lot-row">

            <td class="lot-number-cell">
              ${escapeHtml(
                value.lot_number ||
                  ""
              )}
            </td>

            <td class="image-cell">
              ${
                value.img_url
                  ? `
                    <img
                      src="${escapeHtml(
                        value.img_url
                      )}"
                      alt="Lot"
                      class="lot-image"
                    />
                  `
                  : `
                    <div class="no-image">
                      No Image
                    </div>
                  `
              }
            </td>

            <td class="details-cell">

              <div class="artist">
                ${escapeHtml(
                  artist
                )}
              </div>

              <div class="title">
                ${escapeHtml(
                  title
                )}
              </div>

              ${
                value.signed_dated
                  ? `
                    <div class="meta">
                      <strong>
                        Signed / Dated:
                      </strong>
                      ${escapeHtml(
                        value.signed_dated
                      )}
                    </div>
                  `
                  : ""
              }

              ${
                value.medium
                  ? `
                    <div class="meta">
                      <strong>
                        Medium:
                      </strong>
                      ${escapeHtml(
                        value.medium
                      )}
                    </div>
                  `
                  : ""
              }

              ${
                value.size
                  ? `
                    <div class="meta">
                      <strong>
                        Size:
                      </strong>
                      ${escapeHtml(
                        value.size
                      )}
                    </div>
                  `
                  : ""
              }

            </td>

            <td class="price-cell">
              ${formatMoney(
                value.hp || 0
              )}
            </td>

          </tr>
        `;
      })
      .join("");

    // =========================
    // ADD-ONS
    // =========================

    const addonRows = inputs
      .filter(
        (item) =>
          parseFloat(
            item.price || 0
          ) !== 0
      )
      .map(
        (item) => `
          <tr>

            <td
              colspan="3"
              class="summary-label-cell"
            >
              ${escapeHtml(
                item.discription ||
                  ""
              )}
            </td>

            <td class="summary-price-cell">
              ${formatMoney(
                item.price
              )}
            </td>

          </tr>
        `
      )
      .join("");

    // =========================
    // STAFF
    // =========================

    const staffName =
      `${window.Api?.request?.username || ""} ${
        window.Api?.request?.groupName || ""
      }`.trim();

    // Fallback from imported Api unavailable
    const releasingBy =
      staffName || "";

    // =========================
    // FULL HTML
    // =========================

    printWindow.document.open();

    printWindow.document.write(`
      <!DOCTYPE html>

      <html>

        <head>

          <meta charset="UTF-8" />

          <title>
            STATEMENT OF ACCOUNT
          </title>

          <style>

            @page {
              size: A4 portrait;
              margin: 0;
            }

            * {
              box-sizing: border-box;
            }

            html,
            body {
              margin: 0;
              padding: 0;

              background:
                #e5e7eb;

              color: #000;
            }

            body {
              font-family:
                Arial,
                Helvetica,
                sans-serif;

              font-size:
                12px;

              line-height:
                1.5;

              padding-bottom:
                40px;
            }


            /* =====================
               TOP BAR
            ===================== */

            .topbar {

              position:
                sticky;

              top: 0;

              z-index: 1000;

              height:
                60px;

              width:
                100%;

              background:
                #ffffff;

              border-bottom:
                1px solid #d1d5db;

              box-shadow:
                0 2px 8px
                rgba(
                  0,
                  0,
                  0,
                  0.08
                );

              display:
                flex;

              align-items:
                center;

              justify-content:
                flex-end;

              padding:
                0 20px;
            }


            .print-button {

              border:
                none;

              outline:
                none;

              background:
                #1976d2;

              color:
                #ffffff;

              padding:
                10px 18px;

              border-radius:
                6px;

              font-family:
                Arial,
                Helvetica,
                sans-serif;

              font-size:
                14px;

              font-weight:
                600;

              cursor:
                pointer;

              display:
                inline-flex;

              align-items:
                center;

              gap:
                8px;
            }


            .print-button:hover {
              background:
                #1565c0;
            }


            /* =====================
               A4 PAPER
            ===================== */

            .paper {

              width:
                210mm;

              min-height:
                297mm;

              margin:
                25px auto;

              padding:
                18mm;

              background:
                #ffffff;

              box-shadow:
                0 5px 25px
                rgba(
                  0,
                  0,
                  0,
                  0.15
                );
            }


            /* =====================
               HEADER
            ===================== */

            .header {

              width:
                100%;

              display:
                flex;

              align-items:
                flex-start;

              justify-content:
                space-between;

              padding-bottom:
                12px;

              border-bottom:
                1px solid #000;
            }


            .logo {

              width:
                180px;

              height:
                auto;

              object-fit:
                contain;
            }


            .contact {

              text-align:
                right;

              font-size:
                10px;

              line-height:
                1.5;
            }


            .contact p {
              margin:
                0;
            }


            /* =====================
               TITLE
            ===================== */

            .document-title {

              text-align:
                center;

              font-size:
                18px;

              font-weight:
                700;

              margin:
                22px 0;

              letter-spacing:
                0.3px;
            }


            /* =====================
               INFO
            ===================== */

            .info {

              width:
                100%;

              margin-bottom:
                18px;
            }


            .info-row {

              display:
                flex;

              width:
                100%;

              margin-bottom:
                6px;

              font-size:
                12px;
            }


            .info-label {

              width:
                60px;

              font-weight:
                700;
            }


            .info-value {
              flex: 1;
            }


            /* =====================
               DESCRIPTION
            ===================== */

            .description {

              font-size:
                12px;

              text-align:
                justify;

              line-height:
                1.6;

              margin:
                15px 0 20px;
            }


            .indent {
              padding-left:
                28px;
            }


            /* =====================
               LOT TABLE
            ===================== */

            .lot-table {

              width:
                100%;

              border-collapse:
                collapse;

              border:
                0.5pt solid #000;
            }


            .lot-table th {

              border:
                0.5pt solid #000;

              padding:
                8px 6px;

              background:
                #f2f2f2;

              font-size:
                10px;

              font-weight:
                700;

              text-transform:
                uppercase;

              text-align:
                center;
            }


            .lot-table td {

              border:
                0.5pt solid #000;

              padding:
                7px;

              vertical-align:
                top;
            }


            .lot-number-cell {

              width:
                10%;

              text-align:
                center;

              font-size:
                11px;

              font-weight:
                600;
            }


            .image-cell {

              width:
                18%;

              text-align:
                center;

              vertical-align:
                middle !important;
            }


            .details-cell {

              width:
                47%;

              text-align:
                center;
            }


            .price-cell {

              width:
                25%;

              text-align:
                center;

              vertical-align:
                middle !important;

              font-size:
                11px;

              font-weight:
                600;
            }


            .lot-image {

              width:
                90px;

              height:
                65px;

              object-fit:
                contain;

              display:
                block;

              margin:
                0 auto;
            }


            .no-image {

              width:
                90px;

              height:
                65px;

              display:
                flex;

              align-items:
                center;

              justify-content:
                center;

              margin:
                0 auto;

              background:
                #f5f5f5;

              border:
                1px solid #ddd;

              color:
                #777;

              font-size:
                9px;
            }


            .artist {

              font-size:
                10px;

              font-weight:
                700;

              margin-bottom:
                3px;
            }


            .title {

              font-size:
                10px;

              font-style:
                italic;

              margin-bottom:
                5px;
            }


            .meta {

              font-size:
                8px;

              line-height:
                1.4;

              margin-bottom:
                2px;
            }


            /* =====================
               SUMMARY
            ===================== */

            .summary-label-cell {

              border:
                0.5pt solid #000;

              padding:
                7px;

              text-align:
                right;

              font-size:
                10px;



              font-weight:
                600;
            }


            .summary-price-cell {

              border:
                0.5pt solid #000;

              padding:
                7px;

              text-align:
                center;

              font-size:
                11px;
            }


            .total-row {

              background:
                #f9f9f9;
            }


            .total-label {

              border:
                0.5pt solid #000;

              padding:
                9px 7px;

              text-align:
                right;

              font-size:
                11px;

              font-weight:
                700;

              
            }


            .total-value {

              border:
                0.5pt solid #000;

              padding:
                9px 7px;

              text-align:
                center;

              font-size:
                12px;

              font-weight:
                700;
            }


            /* =====================
               SIGNATURE
            ===================== */

            .signature-wrapper {

              margin-top:
                70px;

              display:
                flex;

              justify-content:
                flex-end;

              page-break-inside:
                avoid;
            }


            .signature {

              width:
                220px;

              text-align:
                center;
            }


            .signature-line {

              width:
                220px;

              border-top:
                0.5pt solid #000;

              padding-top:
                5px;
            }


            .signature-text {

              font-size:
                10px;

              font-weight:
                700;

              text-transform:
                uppercase;
            }


            /* =====================
               ADDRESS
            ===================== */

            .address {

              text-align:
                center;

              margin-top:
                45px;

              font-size:
                10px;

              line-height:
                1.5;
            }


            .address p {
              margin:
                0;
            }


            /* =====================
               PRINT
            ===================== */

            @media print {

              html,
              body {
                background:
                  #ffffff;
              }

              body {
                padding:
                  0;
              }

              .topbar {
                display:
                  none !important;
              }

              .paper {

                width:
                  210mm;

                min-height:
                  297mm;

                margin:
                  0;

                padding:
                  18mm;

                box-shadow:
                  none;
              }

              .lot-row {
                page-break-inside:
                  avoid;
              }

              .lot-image {
                page-break-inside:
                  avoid;
              }

              .signature-wrapper {
                page-break-inside:
                  avoid;
              }
            }

          </style>

        </head>


        <body>


          <!-- =====================
               TOP BAR
          ===================== -->

          <div class="topbar">

            <button
              class="print-button"
              onclick="window.print()"
            >
              🖨 Print
            </button>

          </div>


          <!-- =====================
               A4 PAPER
          ===================== -->

          <div class="paper">


            <!-- HEADER -->

            <div class="header">

              <img
                src="/static/logo140.png"
                class="logo"
                alt="Leon Gallery"
              />

              <div class="contact">

                <p>
                  <b>
                    www.leon-gallery.com
                  </b>
                </p>

                <p>
                  leongallerymakati@gmail.com
                </p>

                <p>
                  info@leon-gallery.com
                </p>

              </div>

            </div>


            <!-- TITLE -->

            <div class="document-title">
              STATEMENT OF ACCOUNT
            </div>


            <!-- INFO -->

            <div class="info">

              <div class="info-row">

                <div class="info-label">
                  Name:
                </div>

                <div class="info-value">
                  ${escapeHtml(
                    customerName
                  )}
                </div>

              </div>


              <div class="info-row">

                <div class="info-label">
                  Auction:
                </div>

                <div class="info-value">
                  ${escapeHtml(
                    eventName
                  )}
                </div>

              </div>


              <div class="info-row">

                <div class="info-label">
                  Date:
                </div>

                <div class="info-value">
                  ${escapeHtml(
                    dateStart
                  )}
                </div>

              </div>

            </div>


            <!-- DESCRIPTION -->

            <div class="description">

              <span class="indent">
                This is to acknowledge
                the receipt of full
                payment for the
                item/s consigned by
                <b>
                  ${escapeHtml(
                    customerName
                  )}
                </b>
                to Leon Gallery for
                <b>
                  ${escapeHtml(
                    eventName
                  )}
                </b>
                held last
                ${escapeHtml(
                  dateStart
                )}
                at G/F Eurovilla 1,
                Rufino corner Legazpi
                Streets, Legazpi Village,
                Makati City.
              </span>

            </div>


            <!-- LOT TABLE -->

            <table class="lot-table">

              <thead>

                <tr>

                  <th>
                    Lot #
                  </th>

                  <th>
                    Image
                  </th>

                  <th>
                    Details
                  </th>

                  <th>
                    Hammer Price
                  </th>

                </tr>

              </thead>


              <tbody>

                ${lotRows}

              </tbody>


              <tfoot>

                <!-- SUB TOTAL -->

                <tr>

                  <td
                    colspan="3"
                    class="summary-label-cell"
                  >
                    Sub Total
                  </td>

                  <td
                    class="summary-price-cell"
                  >
                    ${formatMoney(
                      totalSub
                    )}
                  </td>

                </tr>


                <!-- COMMISSION -->

                <tr>

                  <td
                    colspan="3"
                    class="summary-label-cell"
                  >
                    Seller's Commission
                    (
                    ${(
                      consignorPercent *
                      100
                    ).toFixed(2)}
                    %)
                  </td>

                  <td
                    class="summary-price-cell"
                  >
                    ${formatMoney(
                      commissionValue
                    )}
                  </td>

                </tr>


                <!-- ADD ONS -->

                ${addonRows}


                <!-- TOTAL -->

                <tr
                  class="total-row"
                >

                  <td
                    colspan="3"
                    class="total-label"
                  >
                    Total Due
                  </td>

                  <td
                    class="total-value"
                  >
                    ${formatMoney(
                      totalDue
                    )}
                  </td>

                </tr>

              </tfoot>

            </table>


            <!-- SIGNATURE -->

            <div
              class="signature-wrapper"
            >

              <div
                class="signature"
              >

                <div
                  style="
                    min-height:22px;
                    margin-bottom:5px;
                    font-size:10px;
                  "
                >
                  ${escapeHtml(
                    customerName
                  )}
                </div>

                <div
                  class="signature-line"
                >

                  <div
                    class="signature-text"
                  >
                    Signature over
                    printed name
                  </div>

                </div>

              </div>

            </div>


            <!-- ADDRESS -->

            <div
              class="address"
            >

              <p>
                G/F Eurovilla 1,
                Rufino Corner
                Legazpi Streets,
              </p>

              <p>
                Legazpi Village,
                Makati City
              </p>

              <p>
                Philippines
              </p>

              <p>
                Tel no. (632)
                856-2781
              </p>

            </div>


          </div>


          <script>
            window.onload = function () {
              const images =
                Array.from(
                  document.images
                );

              if (
                images.length === 0
              ) {
                return;
              }

              images.forEach(
                function (image) {
                  if (
                    !image.complete
                  ) {
                    image.onload =
                      function () {};
                    image.onerror =
                      function () {};
                  }
                }
              );
            };
          </script>


        </body>

      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
  };

  // =========================
  // RETURN
  // =========================

  return (
    <Box className={classes.root}>

      <Grid
        container
        spacing={3}
      >

        {/* =====================
            LOT NUMBERS
        ===================== */}

        <Grid
          item
          lg={4}
          md={5}
          xs={12}
        >
          <Card
            className={classes.card}
          >

            <Box
              className={
                classes.sectionHeader
              }
            >

              <Box
                display="flex"
                alignItems="center"
              >

                <Box
                  className={
                    classes.headerIcon
                  }
                >
                  <ReceiptIcon
                    fontSize="small"
                  />
                </Box>

                <Box>

                  <Typography
                    variant="h6"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Lot Numbers
                  </Typography>

                  <Typography
                    variant="body2"
                    className={
                      classes.sectionSubtitle
                    }
                  >
                    Enter the lots to include
                    in the report
                  </Typography>

                </Box>

              </Box>

            </Box>


            <Divider />


            <CardContent
              className={
                classes.content
              }
            >

              <TextField
                multiline
                rows={10}
                fullWidth
                variant="outlined"
                className={
                  classes.lotField
                }
                placeholder={
                  "1\n2\n3"
                }
                value={
                  lotNumberData
                    .replace(
                      /,/g,
                      "\n"
                    )
                }
                onChange={
                  handleLotNumberChange
                }
              />


              <div
                className={
                  classes.lotCount
                }
              >
                {data1.length} lot
                {data1.length !==
                1
                  ? "s"
                  : ""}{" "}
                loaded
              </div>

            </CardContent>

          </Card>
        </Grid>


        {/* =====================
            DETAILS
        ===================== */}

        <Grid
          item
          lg={8}
          md={7}
          xs={12}
        >
          <Card
            className={classes.card}
          >

            <Box
              className={
                classes.sectionHeader
              }
            >

              <Box
                display="flex"
                alignItems="center"
              >

                <Box
                  className={
                    classes.headerIcon
                  }
                >
                  <PersonIcon
                    fontSize="small"
                  />
                </Box>

                <Box>

                  <Typography
                    variant="h6"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Consignment Details
                  </Typography>

                  <Typography
                    variant="body2"
                    className={
                      classes.sectionSubtitle
                    }
                  >
                    Enter consignor,
                    commission and
                    additional charges
                  </Typography>

                </Box>

              </Box>

            </Box>


            <Divider />


            <CardContent
              className={
                classes.content
              }
            >

              {/* EVENT */}

              <Autocomplete
                options={
                  geteventList
                }
                getOptionLabel={(
                  option
                ) =>
                  option.auction_name ||
                  ""
                }
                value={
                  geteventList.find(
                    (item) =>
                      item.id ===
                      eventId
                  ) || null
                }
                onChange={
                  handlepick
                }
                renderInput={(
                  params
                ) => (
                  <TextField
                    {...params}
                    label="Event"
                    variant="outlined"
                    fullWidth
                    className={
                      classes.field
                    }
                    InputProps={{
                      ...params.InputProps,
                      startAdornment:
                        (
                          <>
                            <EventIcon
                              fontSize="small"
                              style={{
                                marginRight: 8,
                                color:
                                  "#9ca3af",
                              }}
                            />

                            {
                              params
                                .InputProps
                                .startAdornment
                            }
                          </>
                        ),
                    }}
                  />
                )}
              />


              {/* CONSIGNOR */}

              <TextField
                fullWidth
                label="Consignor"
                variant="outlined"
                className={
                  classes.field
                }
                value={
                  customerName
                }
                onChange={(e) =>
                  setName(
                    e.target.value
                  )
                }
                placeholder="Enter consignor name"
              />


              {/* COMMISSION */}

              <TextField
                fullWidth
                label="Commission %"
                type="number"
                variant="outlined"
                className={
                  classes.field
                }
                value={
                  consignorPercent
                }
                onChange={(e) =>
                  setConsignorPercent(
                    parseFloat(
                      e.target.value ||
                        0
                    )
                  )
                }
                inputProps={{
                  min: 0,
                  step: 0.001,
                }}
                helperText={`Current commission: ${(
                  consignorPercent *
                  100
                ).toFixed(2)}%`}
              />


              {/* ADD ONS */}

              <Box
                className={
                  classes.addOnsHeader
                }
              >

                <Box>

                  <Typography
                    variant="subtitle1"
                    className={
                      classes.addOnsTitle
                    }
                  >
                    Add-ons
                  </Typography>

                  <Typography
                    variant="caption"
                    color="textSecondary"
                  >
                    Additional deductions
                  </Typography>

                </Box>


                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  startIcon={
                    <AddIcon />
                  }
                  onClick={
                    handleAddInput
                  }
                  style={{
                    textTransform:
                      "none",
                    borderRadius: 8,
                  }}
                >
                  Add
                </Button>

              </Box>


              {inputs.map(
                (
                  item,
                  index
                ) => (

                  <Box
                    key={index}
                    className={
                      classes.addOnRow
                    }
                  >

                    <TextField
                      label="Description"
                      name="discription"
                      size="small"
                      variant="outlined"
                      className={
                        classes.addOnDescription
                      }
                      value={
                        item.discription
                      }
                      onChange={(
                        e
                      ) =>
                        handleChange(
                          e,
                          index
                        )
                      }
                    />


                    <TextField
                      label="Price"
                      name="price"
                      type="number"
                      size="small"
                      variant="outlined"
                      className={
                        classes.addOnPrice
                      }
                      value={
                        item.price
                      }
                      onChange={(
                        e
                      ) =>
                        handleChange(
                          e,
                          index
                        )
                      }
                      inputProps={{
                        min: 0,
                      }}
                    />


                    <IconButton
                      size="small"
                      color="secondary"
                      className={
                        classes.addOnAction
                      }
                      onClick={() =>
                        handleDeleteInput(
                          index
                        )
                      }
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>


                    {index ===
                      inputs.length -
                        1 && (
                      <IconButton
                        size="small"
                        color="primary"
                        className={
                          classes.addOnAction
                        }
                        onClick={
                          handleAddInput
                        }
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    )}

                  </Box>

                )
              )}


              {/* SUMMARY */}

              <Box
                className={
                  classes.summaryBox
                }
              >

                <Typography
                  variant="body2"
                  className={
                    classes.summaryTitle
                  }
                >
                  Amount Summary
                </Typography>


                <Box
                  className={
                    classes.summaryRow
                  }
                >

                  <span
                    className={
                      classes.summaryLabel
                    }
                  >
                    Hammer Subtotal
                  </span>

                  <span
                    className={
                      classes.summaryValue
                    }
                  >
                    {formatMoney(
                      totalSub
                    )}
                  </span>

                </Box>


                <Box
                  className={
                    classes.summaryRow
                  }
                >

                  <span
                    className={
                      classes.summaryLabel
                    }
                  >
                    Seller's Commission
                  </span>

                  <span
                    className={
                      classes.summaryValue
                    }
                  >
                    -
                    {formatMoney(
                      commissionValue
                    )}
                  </span>

                </Box>


                <Box
                  className={
                    classes.summaryRow
                  }
                >

                  <span
                    className={
                      classes.summaryLabel
                    }
                  >
                    Add-ons
                  </span>

                  <span
                    className={
                      classes.summaryValue
                    }
                  >
                    -
                    {formatMoney(
                      totalAddons
                    )}
                  </span>

                </Box>


                <Box
                  className={
                    classes.totalRow
                  }
                >

                  <span
                    className={
                      classes.totalLabel
                    }
                  >
                    Total Due
                  </span>

                  <span
                    className={
                      classes.totalValue
                    }
                  >
                    {formatMoney(
                      totalDue
                    )}
                  </span>

                </Box>

              </Box>

            </CardContent>


            <Divider />


            {/* =====================
                PREVIEW / PRINT
            ===================== */}

            <Box
              className={
                classes.actionSection
              }
            >

              <Button
                variant="contained"
                color="primary"
                className={
                  classes.previewButton
                }
                startIcon={
                  <VisibilityIcon />
                }
                onClick={
                  handlePreviewPrint
                }
              >
                Preview & Print
              </Button>

            </Box>

          </Card>
        </Grid>

      </Grid>


      {/* =========================
          LOADING
      ========================= */}

      <Backdrop
        className={
          classes.backdrop
        }
        open={loading}
      >
        <CircularProgress
          color="inherit"
        />
      </Backdrop>

    </Box>
  );
};

export default Views;